import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS, mobileAndTabletCSS } from '@measures/responsive'
import useHasBlurryBackground from '@hooks/useHasBlurryBackground'
import useHasInvertedColors from '@hooks/useHasInvertedColors'
import useIsInHeroModule from '@hooks/useIsInHeroModule'

export interface CatchwordProps {
  children?: ReactNode
  hasPlusLogo: boolean
}

export interface InvertedColorsStyledProps {
  hasInvertedColors: boolean
}

interface RelatedItemsDesktopStyledProps {
  isInRelatedItemsDesktop: boolean
}

interface HeroModuleStyledProps {
  isInHeroModule: boolean
}

export type StyledCatchwordProps = Pick<CatchwordProps, 'hasPlusLogo'> &
  InvertedColorsStyledProps &
  RelatedItemsDesktopStyledProps &
  HeroModuleStyledProps

const StyledCatchword = styled.div<StyledCatchwordProps>`
  ${({
    theme: {
      spacing: { spacing4 },
      colors: { textBrand, staticRed400, staticNeutral400 },
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadingCSS },
        },
      },
      utils: { ellipsis },
    },
    hasPlusLogo,
    hasInvertedColors,
    isInRelatedItemsDesktop,
    isInHeroModule,
  }) => {
    const color = hasInvertedColors ? staticRed400 : textBrand
    return css`
      ${small1SubheadingCSS};
      color: ${color};
      margin-bottom: ${spacing4};
      ${ellipsis('100%', 2)};
      ${mobileAndTabletCSS(css`
        ${isInHeroModule &&
        css`
          ${ellipsis('100%', 1)};
        `}
      `)};
      ${desktopCSS(css`
        ${isInRelatedItemsDesktop &&
        css`
          color: ${staticNeutral400};
        `};
        ${hasPlusLogo &&
        css`
          line-height: 1.3;
        `};
      `)}
    `
  }}
`

const Catchword: FunctionComponent<CatchwordProps> = ({
  children,
  hasPlusLogo,
}) => {
  const hasInvertedColors = useHasInvertedColors()
  const isInRelatedItemsDesktop = useHasBlurryBackground()
  const isInHeroModule = useIsInHeroModule()

  return (
    <StyledCatchword
      isInRelatedItemsDesktop={isInRelatedItemsDesktop}
      hasPlusLogo={hasPlusLogo}
      hasInvertedColors={hasInvertedColors}
      isInHeroModule={isInHeroModule}
    >
      {children}
    </StyledCatchword>
  )
}

export default Catchword
